export default "__VITE_ASSET__B0a_uITJ__"